import PagesType from "../../types/PagesType";

export const checkPortableMode = (page: PagesType, state: boolean) => {
  return (
    (state || localStorage.getItem("portableMode") === "true") &&
    page === "StatPage"
  );
};
